import Component from "@glimmer/component";

interface Signature {
  Args: {
    /**
     * The size of the content
     */
    size?: "small" | "normal";
    /**
     * The alignment of the text
     */
    alignment?: "center" | "left";
    dataTestValue?: string;
  };
  Blocks: {
    default: [];
  };
}

const STYLES = {
  size: { small: "text-[0.86em]", normal: "text-[1em]" },
  alignment: { center: "text-center", left: "text-left" }
};

export default class NoContentMessage extends Component<Signature> {
  get size(): string {
    return this.args.size ?? "";
  }

  get alignment(): string {
    return this.args.alignment ?? "";
  }

  get style() {
    // @ts-expect-error Ignoring UIKit type errors
    return `${STYLES.size[this.size]} ${STYLES.alignment[this.alignment]}`;
  }
}
